<template>
  <div id="app">
    <NavHeader />
    <router-view></router-view>
  </div>
</template>

<script>
import NavHeader from './components/NavHeader.vue'
export default {
  components: { NavHeader }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style> 